import { clsx } from "clsx";
import { FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";

import { ApiError } from "@/api/rest/core/types";
import { ChangeEmailRequest } from "@/api/rest/models/auth";
import { changeEmail } from "@/api/rest/services/authService";
import { BannerState } from "@/app/account/AccountPage.tsx";

export default function ChangeEmailForm({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [emailChangeResult, setEmailChangeResult] = useState<BannerState | null>(null);

  const submitChangeEmail = async (e: FormEvent<HTMLFormElement>) => {
    const form = e.currentTarget;
    setEmailChangeResult(null);
    e.preventDefault();
    const data = Object.fromEntries(new FormData(form).entries()) as unknown as ChangeEmailRequest; // TODO: proper form validation
    if (!data.newEmail) {
      setEmailChangeResult({
        message: t("account.emailCannotBeEmpty"),
        type: "error",
      });
      return;
    }
    try {
      const result = await changeEmail(data);
      if (result.success) {
        setEmailChangeResult({
          message: t("account.successfulEmailChange"),
          type: "success",
        });
        form.reset();
      } else {
        setEmailChangeResult({ message: result.message, type: "error" });
      }
    } catch (e) {
      const error = e as ApiError;
      setEmailChangeResult({ message: error.message, type: "error" });
    }
  };

  return (
    <form className={className} onSubmit={submitChangeEmail}>
      <input
        className="border border-gray-300 rounded-md p-2"
        type="email"
        name="newEmail"
        autoComplete="email"
        placeholder={t("account.newEmail")}
        required
      />
      {emailChangeResult && (
        <span
          className={clsx(
            `rounded-lg px-4 py-2 text-center`,
            emailChangeResult.type === "success" ? `bg-green-300 text-green-900` : `bg-red-300 text-red-900`,
          )}
        >
          {emailChangeResult.message}
        </span>
      )}
      {emailChangeResult?.type !== "success" && <button className="rounded-md p-2">{t("account.changeEmail")}</button>}
    </form>
  );
}
